/**
 * The global state selectors
 */

import { get } from 'lodash';
import { createSelector } from 'reselect';

const selectGlobal = (state) => get(state, 'global');
const selectRouter = (state) => get(state, 'router');

const makeSelectCurrentRoute = createSelector(
  selectRouter,
  (routerState) => routerState.location,
);

const makeSelectGenericError = createSelector(
  selectGlobal,
  (globalState) => globalState.genericError,
);

const makeSelectGenericErrorValue = createSelector(
  selectGlobal,
  (globalState) => globalState.error,
);

const makeSelectGlobalRoutes = createSelector(
  selectGlobal,
  (globalState) => globalState.routes,
);

export {
  makeSelectCurrentRoute,
  selectGlobal,
  makeSelectGenericError,
  makeSelectGenericErrorValue,
  makeSelectGlobalRoutes,
};
